export default "__VITE_ASSET__Bkzp3fPf__"